import React, { useEffect, useState } from "react";
import EditModal from "@core/modals/EditModal";
import EditButton from "@core/buttons/atoms/EditButton";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import FleetSegmentationService from "@services/FleetSegmentationService";

const EditFleetSegmentation = ({ fleetSegmentation, onEdited }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [alphaCode, setAlphaCode] = useState("");
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEnglishName("");
    setDescription("");
    setAlphaCode("");
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    FleetSegmentationService.update(
      fleetSegmentation.id,
      name,
      englishName,
      description,
      alphaCode
    )
      .then(() => {
        showSuccess(t("fleetSegmentationsEditedSuccessfully"));
        onEdited();
        closeModal();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showModal)
      FleetSegmentationService.find(fleetSegmentation.id).then((response) => {
        setName(response.data.data.name);
        setEnglishName(response.data.data.name_eng);
        setDescription(response.data.data.description);
        setAlphaCode(response.data.data.alpha_code);
      });
  }, [fleetSegmentation.id, showModal]);


  return (
    <PermissionHandler permission={"update_fleet_segmentation"}>
      <EditButton onClick={() => setShowModal(true)} />
      <EditModal
        show={showModal}
        title={t("editFleetSegmentations")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
        label={t("edit")}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5">
          <Input
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
            height="h-10"
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <Input
            height="h-10"
            label={t("alphaCode")}
            placeholder={t("alphaCode")}
            value={alphaCode}
            onChange={setAlphaCode}
          />
        </div>
      </EditModal>
    </PermissionHandler>
  );
};

export default EditFleetSegmentation;
